module.exports = __webpack_public_path__ + "static/media/broom.96eccb9a.svg";